import { render, staticRenderFns } from "./CoachesTable.vue?vue&type=template&id=38ef985e&"
import script from "./CoachesTable.vue?vue&type=script&lang=js&"
export * from "./CoachesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports